module.exports = __webpack_public_path__ + "resources/img/img_codesign2_en.4f3d4885009efe30a335fd4b35ca33af.png";